import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import channelInfoFragment from 'shared/graphql/fragments/channel/channelInfo';

export const archiveChannelMutation = gql`
  mutation archiveChannel($input: ArchiveChannelInput!) {
    archiveChannel(input: $input) {
      ...channelInfo
    }
  }
  ${channelInfoFragment}
`;

const archiveChannelOptions = {
  props: ({ mutate }) => ({
    archiveChannel: input =>
      mutate({
        variables: {
          input,
        },
      }),
  }),
};

export default graphql(archiveChannelMutation, archiveChannelOptions);
